<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item >首页</el-breadcrumb-item>
            <el-breadcrumb-item style="margin-bottom:20px">社交账号管理</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" label-width="30px" class="user-search">
            <el-form-item label=" ">
                <el-button size="small" type="primary" @click="addClick">新增账号</el-button>
            </el-form-item>
        </el-form>
        <el-table size="small" :data="listData" highlight-current-row border style="width:800px">
        <el-table-column  prop="nickname" label="昵称" align="center" ></el-table-column>
        <el-table-column  prop="name" label="头像" align="center" >
            <template slot-scope="scope" align="center">
                <el-image
                    style="width: 200px; height: 100px"
                    class="img_inner"
                    :src="scope.row.avatar"
                    fit="fit"></el-image>
            </template>
        </el-table-column>
        <el-table-column  prop="content" label="简介" align="center" ></el-table-column>
        <el-table-column  prop="name" label="背景" align="center" >
            <template slot-scope="scope" align="center">
                <el-image
                    style="width: 200px; height: 100px"
                    class="img_inner"
                    :src="scope.row.bg_pic"
                    fit="fit"></el-image>
            </template>
        </el-table-column>
            <el-table-column align="center" label="操作" >
                <template slot-scope="scope">
                <el-button type="text" v-preventReClick @click="handleEdit(scope.row)">修改</el-button>
                <el-button type="text" v-preventReClick @click="delClick(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

        <el-dialog :visible.sync="editFormVisible" width="30%" @click="closeDialog">
            <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
                <el-form-item label="昵称" prop="nickname">
                    <el-input el-input size="small" v-model="editForm.nickname" auto-complete="off" placeholder="请输入行业"></el-input>
                </el-form-item>
                <el-form-item label="头像" prop="avatar">
                    <img style="width:300px;height:200px" v-if="editForm.avatar != ''" :src="editForm.avatar">
                    <el-upload
                        :http-request="headImgChange"
                        :file-list="headImgFileList"
                        multiple
                        limit="1"
                        accept=".jpg , .png ,"
                        >
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="简介" prop="content">
                    <el-input el-input size="small" v-model="editForm.content" auto-complete="off" placeholder="请输入行业"></el-input>
                </el-form-item>
                <el-form-item label="性别" prop="gender">
                    <el-radio-group v-model="editForm.gender">
                        <el-radio :label="1">男</el-radio>
                        <el-radio :label="0">女</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="背景" prop="bg_pic">
                    <img style="width:300px;height:200px" v-if="editForm.bg_pic != ''" :src="editForm.bg_pic">
                    <el-upload
                        :http-request="bgImgChange"
                        :file-list="bgImgFileList"
                        multiple
                        limit="1"
                        accept=".jpg , .png ,"
                        >
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeDialog">取消</el-button>
                <el-button size="small" type="primary" v-preventReClick :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>
    
<script>
import Pagination from '../../components/Pagination'
import {officialUsersList , addUsersAdmin , usersUpdate , officialUsersDel } from '../../api/userMG'
export default {
    data () {
        return {
            loading:false,
            rules:{},
            editFlag:false,
            editForm:{
                name:'',
                id:'',
            },
            editFormVisible:false,
            content: '<h2>I</h2><p>这是射，么就卡奇我觉额定</p><p>啊索拉卡到家啊了肯定</p><p>接口</p>',
            editorOption: {
            // Some Quill options...
            },
            formInline: {
                page: 1,
                limit: 10,
                phone: '',
                nickName: '',
            },
            listData: [], //用户数据
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            rules: {
                avatar: [
                { required: true, message: '请上传头像', trigger: 'blur' }
                ],
                bg_pic: [
                { required: true, message: '请上传背景', trigger: 'blur' }
                ],
                content: [
                { required: true, message: '请输入简介', trigger: 'blur' }
                ],
                nickname: [
                { required: true, message: '请输入名称', trigger: 'blur' }
                ],
                gender: [
                { required: true, message: '请选择性别', trigger: 'blur' }
                ],
            },
            headImgFileList:[],
            headImgUrl:'',
            bgImgFileList:[],
            bgImgUrl:'',

        }
    },
    components: {
        Pagination
    },
    created(){
        this.getdata()
    },
    methods: {
        headImgChange(file){
            let formData = new FormData()
            formData.append('file' , file.file)
            this.$axios({
                method: "POST",
                url: "/yunyue-houtai/file/upload",
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: localStorage.getItem("logintoken"),//token值，根据接口要求传或者不传
                },
                data: formData,
            }).then(res=>{
                this.editForm.avatar = res.data.data
                this.headImgFileList = []
            })
        },
        bgImgChange(file){
            let formData = new FormData()
            formData.append('file' , file.file)
            this.$axios({
                method: "POST",
                url: "/yunyue-houtai/file/upload",
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: localStorage.getItem("logintoken"),//token值，根据接口要求传或者不传
                },
                data: formData,
            }).then(res=>{
                this.editForm.bg_pic = res.data.data
                this.bgImgFileList = []
            })
        },
        delClick(row){
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                officialUsersDel({id:row.id}).then(res=>{
                    if(res.success){
                        this.$message.success("操作成功")
                        this.getdata()
                    }else{
                        this.$message.error(res.messages)
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },  
        addClick(){
            this.editFlag = false
            this.editFormVisible = true
            this.editForm = {
                nickName:'',
                content:'',
                avatar:'',
                bg_pic:'',
                gender:""
            }
        },  
        submitForm(form){
            this.$refs[form].validate(valid => {
                if (valid) {
                    if(this.editForm.id == undefined){
                        addUsersAdmin(this.editForm).then(res=>{
                            if(res.success){
                                this.$message.success("操作成功")
                                this.editForm = {
                                    nickName:'',
                                    content:'',
                                    avatar:'',
                                    bg_pic:'',
                                    gender:""
                                }
                                this.editFormVisible = false
                                this.getdata()
                            }else{
                                this.$message.error(res.messages)
                            }
                        })
                    }else {
                        usersUpdate(this.editForm).then(res=>{
                            if(res.success){
                                this.$message.success("操作成功")
                                this.editForm = {
                                    nickName:'',
                                    content:'',
                                    avatar:'',
                                    bg_pic:'',
                                    gender:''
                                }
                                this.editFormVisible = false
                                this.getdata()
                            }else{
                                this.$message.error(res.messages)
                            }
                        })
                    }
                    
                } else {
                    return false
                }
            })
        },  

        
        handleEdit(row){
            let data = JSON.parse(JSON.stringify(row))
            this.editForm = {
                id:data.id,
                avatar:data.avatar,
                bg_pic:data.bg_pic,
                nickname:data.nickname,
                content:data.content,
                gender:data.gender
            }
            this.editFormVisible = true
        },
        closeDialog(){
            this.$refs.editForm.clearValidate();
            this.editFormVisible = false
        },
        addBanner(){
            this.editFormVisible = true
        },
        getdata(){
            officialUsersList({
                page:this.formInline.page,
                size:this.formInline.limit,
                type:1
            }).then(res=>{
                this.listData = res.data.dataList
                this.pageparm.total = res.data.total
            })
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.limit = parm.pageSize
            this.getdata(this.formInline)
        },
    },
    computed: {
		editor() {
			return this.$refs.myQuillEditor.quill
		}
    },
    mounted() {
    // console.log('this is current quill instance object', this.editor)
    },
}
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>


// WEBPACK FOOTER //
// src/views/socialize/SocialAccounts.vue